const HomePage = {};
const ProgramsPage = {};
const Button = {};
const NavDrawer = {};
const ProgramSection = {};
const FlexHeader = {};
const ContactForm = {};
const ContactPage = {};
const Crumbs = {};

Crumbs.home = {
  en: 'Home',
  es: 'Home',
}

Crumbs.programs = {
  en: 'Programs',
  es: 'Programas',
}

Crumbs.contact = {
  en: 'Contact us',
  es: 'Contactos',
}

ContactPage.title = {
  en: 'Contact us',
  es: 'Contactos',
}

ContactPage.subtitle = {
  en: 'To learn more about schedules, availability, and our programs, feel free to contact us anytime.',
  es: 'Siéntete libre a contactarnos sobre horarios, disponibilidad, y nuestros programas a cualquier hora.',
}

ContactForm.contactUs = {
  en: 'Contact us',
  es: 'Contactos',
}

FlexHeader.programs = {
  en: 'Programs',
  es: 'Programas',
}

FlexHeader.contact = {
  en: 'Contact',
  es: 'Contactos',
}

ProgramSection.hide = {
  en: 'Hide',
  es: 'Menos'
}

ProgramSection.details = {
  en: 'Details',
  es: 'Detalles'
}

NavDrawer.home = {
  en: 'Home',
  es: 'Home',
}

NavDrawer.programs = {
  en: 'Programs',
  es: 'Programas',
}

Button.viewPrograms = {
  en: 'View Programs',
  es: 'Ver Programas',
}

HomePage.title = {
  en: 'Historia',
  es: 'Historia',
}
HomePage.subtitle = {
  en: 'Learning Cooperative',
  es: 'Cooperativo de Aprendizaje',
}

HomePage.p1 = {
  en: 'Historia Learning Cooperative seeks to empower communities through education in technology, language, and organizing.  Our program is driven by the needs of members, their families, and the larger community.',
  es: 'Historia Cooperativo de Aprendizaje busca empoderar a las comunidades a través de la educacíon en tecnología, idioma, y organización. Nuestro programa está impulsado por las necesidades de los miembros, sus familias, y la comunidad.'
}

HomePage.p2 = {
  en: 'We see learning as a continuous activity that promotes our ability to understand our world and to actively participate in the transformation of our conditions.',
  es: 'Nosotros vemos el aprendizaje como una actividad continua que promueve nuestra abilidad de entender nuestro mundo y participar activamente en la transformación de nuestras condiciones.',
}

HomePage.p3 = {
  en: 'Currently, our major programs of study include:',
  es: 'Actualmente, nuestros programas de estudio principales incluyen:'
}

HomePage.p4 = {
  en: '1. Language (English and Spanish)',
  es: '1. Idioma (inglés y español)',
}

HomePage.p5 = {
  en: '2. Technology (basic computer use, web development, advanced software engineering)',
  es: '2. Tecnología (uso básico de computadores, desarrollo web, ingeniería de software avanzada)'
}

HomePage.p6 = {
  en: 'However, our catalog is constantly evolving according to the needs of members.',
  es: 'Sin embargo, nuestro catálogo está evolucionando constantemente según las necesidades de los miembros.'
}

HomePage.p7 = {
  en: 'We focus on achieving concrete results for our members, measured in terms of professional development, job opportunities, and community participation.',
  es: 'Nos enfocamos en realizar resultados concretos para nuestros miembros, medidos en términos de desarrollo profesional, oportunidades de trabajo, y participación comunitaria.',
}

HomePage.p8 = {
  en: 'Contact us for more information!',
  es: '¡Contáctenos para más información!'
}


ProgramsPage.title = {
  en: 'Our programs',
  es: 'Nuestros programas',
}

ProgramsPage.subtitle = {
  en: 'Our learning programs are designed to be flexible and accomodating to the needs of our members. They are always evolving to better serve that goal.',
  es: 'Nuestros programas de aprendizaje son diseñados a ser flexible a las necesidades de nuestros miembros. Siempre se están evolucionando para mejor cumplir esa meta.',
}

export {
  HomePage,
  ProgramsPage,
  Button,
  NavDrawer,
  ProgramSection,
  FlexHeader,
  ContactForm,
  ContactPage,
  Crumbs,
};



// WEBPACK FOOTER //
// ./src/strings.js